/* global gtag */
import React, { useState } from "react";
import { Alert, Spinner, FormGroup, Form } from "reactstrap";
import { ButtonLogin, InputLogin } from "./styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { useHistory } from "react-router-dom";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";

function Login() {
  let [username, setUsername] = useState("");
  let [password, setPassword] = useState("");
  let [inProgress, setInProgress] = useState(false);
  let [error, setError] = useState(false);
  let [msgError, setMsgError] = useState("erro");
  let history = useHistory();

  const login = async (e) => {
    e.preventDefault();
    setInProgress(true);

    const response = await api().user().login({ username, password });

    if (response.status === 200) {
      if (response.output.user.role === "hmsj") {
        await cookie().set("username", username);
        await cookie().set("role", response.output.user.role);
        await cookie().set("tokenDoc", response.output.token);
        gtag("event", "login_success_hmsj", {
          event_category: "auth",
          value: 200,
        });
        return history.push({ pathname: "/files" });
      }

      if (response.output.user.role === "unimed") {
        await cookie().set("username", username);
        await cookie().set("role", response.output.user.role);
        await cookie().set("tokenDoc", response.output.token);
        gtag("event", "login_success_unimed", {
          event_category: "auth",
          value: 200,
        });
        return history.push({ pathname: "/reports" });
      }
      if (response.output.user.role === "cho") {
        await cookie().set("username", username);
        await cookie().set("role", response.output.user.role);
        await cookie().set("tokenDoc", response.output.token);
        gtag("event", "login_success_cho", {
          event_category: "auth",
          value: 200,
        });
        return history.push({ pathname: "/reportsCho" });
      }

      if (response.output.user.role === "redeSus") {
        await cookie().set("username", username);
        await cookie().set("role", response.output.user.role);
        await cookie().set("tokenDoc", response.output.token);
        gtag("event", "login_success_redeSus", {
          event_category: "auth",
          value: 200,
        });

        return history.push({ pathname: "/reports-rede-sus" });
      }

      if (response.output.user.role === "tumorBoard") {
        await cookie().set("username", username, 5 / 24);
        await cookie().set("role", response.output.user.role, 5 / 24);
        await cookie().set("tokenDoc", response.output.token, 5 / 24);
        gtag("event", "login_success_boardOncologico", {
          event_category: "auth",
          value: 200,
        });

        return history.push({ pathname: "/tumor-board" });
      }

      await cookie().set("name", response.output.user.name, 5 / 24);
      await cookie().set("username", username, 5 / 24);
      await cookie().set("role", response.output.user.role, 5 / 24);
      await cookie().set("code", response.output.user.code, 5 / 24);
      await cookie().set("CodTitulo", response.output.user.CodTitulo, 5 / 24);
      await cookie().set(
        "requirePermission",
        response.output.user.require_permission,
        5 / 24,
      );
      await cookie().set("DocList", "false", 5 / 24);
      await cookie().set("token", response.output.token, 5 / 24);
      gtag("event", "login_success", {
        event_category: "auth",
        value: 200,
      });

      return history.push({ pathname: "/" });
    }
    if (response.status === 428) {
      let name = response.output.user.name;
      return history.push({
        pathname: "/info-verify",
        state: {
          username: username,
          firstName: name,
          role: response.output.user.role,
          codTitulo: response.output.user.CodTitulo,
          codeDoctor: response.output.user.code,
          requirePermission: response.output.user.require_permission,
          mail: response.output.user.mail,
          tel: response.output.user.tel,
          crm: response.output.user.CRM,
          name: response.output.user.name,
          id: response.output.user.id,
          token: response.output.token,
        },
      });
    }
    setMsgError(response.message);
    setError(true);
    setInProgress(false);
  };

  return (
    <>
      {error && <Alert color="danger">{msgError}</Alert>}

      <Form onSubmit={login}>
        <FormGroup>
          <InputLogin
            type="text"
            placeholder="Digite seu login"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <InputLogin
            type="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormGroup>

        {inProgress ? (
          <Spinner color="primary" />
        ) : (
          <ButtonLogin color="primary" type="submit">
            Logar <FontAwesomeIcon icon={faArrowRight} />
          </ButtonLogin>
        )}
      </Form>
    </>
  );
}

export default Login;
